import {
  BookOpen,
  Mail,
  Youtube,
  Instagram,
  Heart,
  LucideIcon,
} from 'lucide-react';

export interface QuickLink {
  label: string;
  href: string;
}

export interface LegalLink {
  label: string;
  href: string;
}

export interface SocialLink {
  icon: LucideIcon;
  href: string;
  title: string;
  size: number;
  group?: 'youtube' | 'other';
}

export interface FooterData {
  brand: {
    name: string;
    description: string;
    icon: LucideIcon;
  };
  quickLinks: QuickLink[];
  legalLinks: LegalLink[];
  socialLinks: SocialLink[];
  bottomLinks: QuickLink[];
}

export const footerData: FooterData = {
  brand: {
    name: 'Minifictionverse',
    description: "Mini's world.",
    icon: BookOpen,
  },
  quickLinks: [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' },
  ],
  legalLinks: [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
  ],
  socialLinks: [
    {
      icon: Youtube,
      href: 'https://www.youtube.com/@PurpleKook9',
      title: 'PurpleKook',
      size: 18,
      group: 'youtube',
    },
    {
      icon: Youtube,
      href: 'https://www.youtube.com/@MiniTaeFF',
      title: 'MiniTaeff',
      size: 18,
      group: 'youtube',
    },
    {
      icon: Youtube,
      href: 'https://www.youtube.com/@MiniFantasyFics',
      title: 'MiniFantasyFics',
      size: 18,
      group: 'youtube',
    },
    {
      icon: Instagram,
      href: 'https://www.instagram.com/author.mini/',
      title: 'Instagram',
      size: 20,
      group: 'other',
    },
    {
      icon: Heart,
      href: 'https://buymeacoffee.com/miniff',
      title: 'Support Me',
      size: 20,
      group: 'other',
    },
    {
      icon: Mail,
      href: 'mailto:helpdesk@minifanfictionverse.site',
      title: 'Email',
      size: 20,
      group: 'other',
    },
  ],
  bottomLinks: [
    { label: 'Privacy', href: '/privacy' },
    { label: 'Terms', href: '/terms' },
    { label: 'Contact', href: '/contact' },
  ],
};
